import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  ConfigDataResolver,
  ContentResolverService, MetaServiceResolver, PostsResolver,
  RealEstateResolver
} from '@ed-clients/shared';

import {HomeComponent} from './home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      content: {
        target: 'staticpages',
        slug: 'home'
      },
      deps: {
        content: ContentResolverService,
        posts: PostsResolver,
        realEstates: RealEstateResolver,
        configData: ConfigDataResolver
      },
      metaCombination: {
        mainMeta: 'configData',
        blackbird: ['posts', 'configData', 'content'],
        shopware: ['realEstates'],
        includeShopwareSchemasOnly: true
      }
    },
    resolve: {
      meta: MetaServiceResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {
}
